import { viewAsHeaders } from "../../DevTools/viewAs";
// frontend/src/releaseNotes/uploadDeployNoteMedia.thunk.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import type { IBlobMedia } from "@multiconsult-group/multiplacer-core";
import { apiRTK } from "../../apiRTK";
import { getApiBaseUrl } from "../../utils";

export type TUploadDeployNoteMediaArgs = {
  deployNoteId: string;
  changeItemId: string;
  file: File;
};

export type TUploadDeployNoteMediaResult = {
  uploaded: {
    id: string;
    originalFileName: string;
    blobName: string;
    contentType: string;
    sizeBytes: number;
    createdAt: string;
  };
  media: IBlobMedia;
};

export const uploadDeployNoteMediaThunk = createAsyncThunk<
  TUploadDeployNoteMediaResult,
  TUploadDeployNoteMediaArgs
>("releaseNotes/uploadDeployNoteMedia", async (args, thunkApi) => {
  try {
    const form = new FormData();
    form.append("file", args.file);

    const res = await fetch(
      `${getApiBaseUrl()}/api/multiplacer/release-notes/deploy-notes/${args.deployNoteId}/change-items/${args.changeItemId}/assets`,
      {
        method: "POST",
        body: form,
          headers: viewAsHeaders(),
        // Viktig hvis dere bruker cookie/session auth (typisk bak protected endpoints)
        credentials: "include",
      }
    );

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error(txt || `Upload feilet (${res.status})`);
    }

    const json = (await res.json()) as TUploadDeployNoteMediaResult;

    // Sørg for at RTK Query refetcher deploy-notes/listene
    thunkApi.dispatch(apiRTK.util.invalidateTags(["ReleaseNotes"]));

    return json;
  } catch (e: any) {
    return thunkApi.rejectWithValue(e?.message ?? "Upload feilet");
  }
});
